"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var formatCurrency_1 = require("../utils/formatCurrency");
var AxiosClient_1 = require("../utils/AxiosClient");
var js_cookie_1 = __importDefault(require("js-cookie"));
var QttProps = {
    min: 1,
    autoFocus: true,
};
function CartCard(props) {
    var image = props.image, productName = props.productName, quantity = props.quantity, price = props.price, id = props.id;
    var _a = (0, react_1.useState)(quantity), qtt = _a[0], setQtt = _a[1];
    var _b = (0, react_1.useState)({
        image: "",
        quantity: 0,
        id: 0,
        productName: "",
        price: 0,
    }), updateItem = _b[0], setUpdateItem = _b[1];
    var _c = (0, react_1.useState)(false), open = _c[0], setOpen = _c[1];
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    var openDialog = function () { return setOpen(true); };
    var closeDialog = function () { return setOpen(false); };
    var _e = (0, react_1.useState)(false), disabled = _e[0], setDisabled = _e[1];
    var token = js_cookie_1.default.get("token");
    var handleDeleteSingle = function (cart_id) {
        setDisabled(true);
        AxiosClient_1.AxiosClient.delete("/cart/remove/".concat(cart_id), {
            headers: { Authorization: "Bearer ".concat(token) },
        })
            .then(function (response) {
            console.log(response.data);
            if (response.data.statusCode == 200) {
                setDisabled(false);
                window.location.reload();
            }
        })
            .catch(function (error) {
            console.log(error);
        })
            .finally(function () { return setDisabled(false); });
    };
    var handleUpdateCart = function (cart) {
        openDialog();
        setUpdateItem(cart);
    };
    var handleQuantityChange = function (event) {
        setQtt(parseInt(event.target.value));
    };
    var updateQuantity = function () {
        setLoading(true);
        AxiosClient_1.AxiosClient.patch("/cart/".concat(updateItem.id), { itemQuantity: qtt }, { headers: { Authorization: "Bearer ".concat(token) } })
            .then(function (response) {
            if (response.data.statusCode == 200) {
                window.location.reload();
            }
        })
            .catch(function (error) {
            console.log(error);
        })
            .finally(function () { return setLoading(false); });
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.Container, { component: "main", maxWidth: "sm" },
            react_1.default.createElement(material_1.CssBaseline, null),
            react_1.default.createElement(material_1.Box, { sx: {
                    marginTop: 3,
                    boxShadow: "0 0 10px 0 rgba(0,0,0,.5)",
                    borderRadius: "7px",
                    "& > :not(style)": {
                        p: "10px",
                    },
                } },
                react_1.default.createElement("div", { className: "header", style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                    } },
                    react_1.default.createElement(material_1.Typography, { sx: { fontWeight: 700 } }, "Shopping cart"),
                    react_1.default.createElement(material_1.Button, { variant: "text", disabled: disabled, sx: { textTransform: "capitalize" }, color: "error", onClick: function () { return handleDeleteSingle(id); } }, "Remove")),
                react_1.default.createElement("div", { className: "body", style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                    } },
                    react_1.default.createElement("img", { src: image, alt: productName, style: { width: 100, borderRadius: "5px" } }),
                    react_1.default.createElement(material_1.Typography, { sx: {
                            fontWeight: "bolder",
                            cursor: "pointer",
                            "&:hover": { color: "blue" },
                        }, onClick: function () { return handleUpdateCart(props); } }, productName),
                    react_1.default.createElement(material_1.Typography, null, quantity),
                    react_1.default.createElement(material_1.Typography, { sx: { fontWeight: 600 } }, (0, formatCurrency_1.formatCurrency)(price))),
                react_1.default.createElement(material_1.Divider, null),
                react_1.default.createElement(material_1.Typography, { sx: { fontWeight: 600 } },
                    " ",
                    "Total: ",
                    (0, formatCurrency_1.formatCurrency)(price * quantity),
                    " "))),
        react_1.default.createElement(material_1.Dialog, { open: open, onClose: closeDialog },
            react_1.default.createElement(material_1.DialogTitle, null, updateItem.productName),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.DialogContentText, { gutterBottom: true }, "Feel free to change the quantity of your product."),
                react_1.default.createElement(material_1.TextField, { label: "Product Quantity", type: "number", fullWidth: true, defaultValue: updateItem.quantity, onChange: handleQuantityChange, inputProps: QttProps, variant: "filled" })),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { disabled: loading, onClick: closeDialog, color: "error" }, "Cancel"),
                react_1.default.createElement(material_1.Button, { disabled: loading, onClick: updateQuantity, variant: "contained", color: "success" }, "Confirm")))));
}
exports.default = CartCard;
